module.exports = __webpack_public_path__ + "static/img/旋翼无人机.29afd28.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/旋翼无人机.png
// module id = WCcS
// module chunks = 1